import { computed, type ComputedRef } from 'vue'

export function useBookingLimitsErrorMessage(
    totalEnrollmentCount: ComputedRef<number>,
    minimumEnrollments: ComputedRef<number | null>,
    maximumEnrollments: ComputedRef<number | null>
) {
    return computed(() => {
        if (
            minimumEnrollments.value !== null &&
            totalEnrollmentCount.value < minimumEnrollments.value
        ) {
            if (minimumEnrollments.value === 1) {
                return 'Booking must have at least 1 participant'
            } else {
                return (
                    'Booking must have at least ' +
                    minimumEnrollments.value +
                    ' participants'
                )
            }
        }

        if (
            maximumEnrollments.value !== null &&
            totalEnrollmentCount.value > maximumEnrollments.value
        ) {
            return 'Maximum participants allowed is ' + maximumEnrollments.value
        }

        return null
    })
}
